/**
 * The folder view's glyphs — Lucide's `check`, `more-vertical`, `filter`,
 * `pencil`, `trash-2` and `plus`, hand-copied because this workspace carries
 * no `lucide-react` dependency. The three boxed ones share a `size-4` wrapper
 * so the manage panel's four rows start every glyph at the same x.
 */

export function CheckIcon() {
  return (
    <svg
      viewBox="0 0 24 24"
      width={14}
      height={14}
      fill="none"
      stroke="currentColor"
      strokeWidth={3}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <path d="M20 6 9 17l-5-5" />
    </svg>
  );
}

export function MoreActionsIcon() {
  return (
    <svg
      viewBox="0 0 24 24"
      width={16}
      height={16}
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <circle cx="12" cy="12" r="1" />
      <circle cx="12" cy="5" r="1" />
      <circle cx="12" cy="19" r="1" />
    </svg>
  );
}

/** Lucide's `filter`, hand-copied (no `lucide-react` dependency) — same
    conventions as `MoreActionsIcon` above. */

export function FilterIcon() {
  return (
    <svg
      viewBox="0 0 24 24"
      width={16}
      height={16}
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3" />
    </svg>
  );
}

/**
 * Lucide's `pencil`, hand-copied (no `lucide-react` dependency) — Rename's
 * glyph, `size-4`-boxed like `ToggleBox` above so its stroke lines up with
 * the checkboxes two rows up rather than sitting flush against the text.
 */
export function PencilIcon() {
  return (
    <span aria-hidden="true" className="flex size-4 shrink-0 items-center justify-center">
      <svg
        viewBox="0 0 24 24"
        width={14}
        height={14}
        fill="none"
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M12 20h9" />
        <path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4Z" />
      </svg>
    </span>
  );
}

/** Lucide's `trash-2`, hand-copied — Delete's glyph, boxed like `PencilIcon` above. */

export function TrashIcon() {
  return (
    <span aria-hidden="true" className="flex size-4 shrink-0 items-center justify-center">
      <svg
        viewBox="0 0 24 24"
        width={14}
        height={14}
        fill="none"
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M3 6h18" />
        <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" />
        <line x1="10" x2="10" y1="11" y2="17" />
        <line x1="14" x2="14" y1="11" y2="17" />
      </svg>
    </span>
  );
}

/** Lucide's `plus`, hand-copied — New subfolder's glyph, boxed like `PencilIcon` above. */

export function PlusIcon() {
  return (
    <span aria-hidden="true" className="flex size-4 shrink-0 items-center justify-center">
      <svg
        viewBox="0 0 24 24"
        width={14}
        height={14}
        fill="none"
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M5 12h14" />
        <path d="M12 5v14" />
      </svg>
    </span>
  );
}
